import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Program} from "@catmodels/programs/types";

@Injectable()
export class ProgramService extends RestHttpService<Program> {

  constructor(service: Restangular) {
    super('programs', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/programs/services/program.service.ts